import styled from 'react-emotion';
import * as css from 'styles'

import View from 'components/View/View';

const Nav = styled(View)({
  textTransform: 'uppercase',
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  zIndex: css.z.nav,

  '& a':{
    transition: css.transition.fast,

    color: css.color.primary,
    // borderBottom: `${css.border.solid} transparent`,
    marginRight: css.space.xs,

    '&:hover, &:focus':{
      // color: css.color.primarysuperlight,
      borderColor: css.color.primary,
      textDecoration: 'underline',
      outline: 'none !important',
    },

    '&.active':{
      // color: css.color.primarydark,
      borderColor: css.color.primarydark,
      textDecoration: 'underline',
    },
  }
})

export default Nav;



// WEBPACK FOOTER //
// ./src/containers/Nav.js